import { useContext } from "react";
import { swayyStoreContext } from "./stores";

/** Mirrors Swageazy `use-stores.tsx` */
export const useStores = () => useContext(swayyStoreContext);
